import { ResponsiveOverlay } from "@/components/ui/ResponsiveOverlay";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import {
  type SortOption,
  SORT_LABELS,
} from "@/lib/exploreParams";
import type { ExploreMode } from "./ExploreModeToggle";

interface ExploreSortSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: ExploreMode;
  currentSort: SortOption;
  hasGeo: boolean;
  onSelect: (sort: SortOption) => void;
}

/** Available sort options per mode */
function sortOptionsForMode(mode: ExploreMode, hasGeo: boolean): SortOption[] {
  if (mode === "do") {
    const opts: SortOption[] = ["soonest"];
    if (hasGeo) opts.push("nearest");
    opts.push("az");
    return opts;
  }
  // places & farms
  const opts: SortOption[] = ["relevance"];
  if (hasGeo) opts.push("nearest");
  opts.push("az");
  return opts;
}

/**
 * Responsive overlay for Explore sorting.
 * Mobile: bottom sheet · Desktop: centered dialog.
 */
export function ExploreSortSheet({
  open,
  onOpenChange,
  mode,
  currentSort,
  hasGeo,
  onSelect,
}: ExploreSortSheetProps) {
  const options = sortOptionsForMode(mode, hasGeo);

  return (
    <ResponsiveOverlay open={open} onOpenChange={onOpenChange} title="Sortera" showHeader>
      <div className="space-y-1 pb-4">
        {options.map((opt) => (
          <button
            key={opt}
            onClick={() => {
              onSelect(opt);
              onOpenChange(false);
            }}
            className={cn(
              "w-full flex items-center justify-between px-4 py-3 rounded-lg text-sm transition-colors",
              currentSort === opt
                ? "bg-primary/10 text-primary font-medium"
                : "text-foreground hover:bg-muted"
            )}
          >
            {SORT_LABELS[opt]}
            {currentSort === opt && <Check className="h-4 w-4" />}
          </button>
        ))}
      </div>
    </ResponsiveOverlay>
  );
}
